import React, { useEffect, useState, useRef } from "react";
import "reactjs-popup/dist/index.css";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import swal from "sweetalert";
import { Col, Card, Table, Alert, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
function DeletedUser() {
  const history = useHistory();
  const datas = document.querySelectorAll("#job_data tbody tr");
  const sort = 10;
  const activePag = useRef(0);
  const [spinner, setSpinner] = useState(true);
  const [data, setData] = useState([]);
  const [searchData, setSearchData] = useState([]);
  const [allusers, setallusers] = useState(true);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );

  function searchFunction(value) {
    let filteredData = [];
    if (searchData) {
      searchData.map((val) => {
        let phoneString = val.Phone.toString();

        if (
          val._id.toLowerCase().includes(value) ||
          val.UserName.toLowerCase().includes(value) ||
          (val.Email && val.Email.toLowerCase().includes(value)) ||
          phoneString.includes(value)
        ) {
          filteredData.push(val);
        }
      });
      setData(filteredData);
    }
  }
  function getData() {
    axios
      .get(`${Baseurl.baseurl}/user/get-deleted-user-details`)
      .then((res) => {
        if (res.data.status) {
          setSpinner(false);
          console.log("djddndnnndd",res.data)
          setData(res.data.deletedUsers);
          setSearchData(res.data.deletedUsers);
        } else {
          swal("No More Data", "", "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < datas.length; ++i) {
      if (i >= frist && i < sec) {
        datas[i].classList.remove("d-none");
      } else {
        datas[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(datas.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Col lg={12}>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            <input
              type="text"
              id="myInput"
              onChange={(e) => {
                searchFunction(e.target.value);
              }}
              className="form-control col-sm-12"
              placeholder="Search here..."
            />
          </div>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center mt-5">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table responsive id="myTable" className="table text-white text-center">
                <thead>
                  <tr>
                    <th>
                      <strong>USER ID.</strong>
                    </th>
                    <th>
                      <strong> NAME</strong>
                    </th>
                    <th>
                      <strong>Email</strong>
                    </th>
                    <th>
                      <strong>Phone</strong>
                    </th>

                    <th>
                      <strong>Reason</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allusers &&
                    data &&
                    data.map((user) => (
                      <tr key={user.id}>
                        <td>{user._id}</td>
                        <td>{user.UserName}</td>
                        <td>{user.Email ? user.Email : "-----"}</td>
                        <td>{user.Phone}</td>
                        <td>{user.Reason}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!data && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero riders
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {datas.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : datas.length}{" "}
                of {datas.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default DeletedUser;
